import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section class=\"page-unavailable row\">\n    <div class=\"column small-12 medium-12 large-12\">\n        <p data-font=\"cnx-regular\"><span class=\"change\">Page unavailable.</span> We're sorry, the Bank of America page you are trying to reach is temporarily unavailable. We apologize for the inconvenience. </p>\n        <p class=\"link-to-homepage\" data-font=\"cnx-regular\"><a id=\"visitOurHomePage\" href=\"/credit-cards/\">Visit our homepage</a></p>\n    </div>\n</section>\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/unavailable-cc-module",
  "version": "1.0.1",
  "id": "unavailableCcModule",
  "containerID": "creditCardsUnavailableCcModule",
  "moduleName": "credit-cards-unavailable-cc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "unavailable-cc-module",
  "data": {
    "options": {},
    "init": "CreditCardsUnavailableCcModule"
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0"
  },
  "stores": []
};

class UnavailableCcModule extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }
  init() {}
}
registerModuleClass({
  moduleClass: UnavailableCcModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { UnavailableCcModule as default, moduleConfig };
